import { createContext } from 'react';
import { DocumentsContextData } from './interfaces/document-context-props.interface';

export const DocumentsContext = createContext<DocumentsContextData>(
    {} as DocumentsContextData,
);
